export enum Customer {
  VIDA = "VIDATERMINO",
  LEY = "LEY",
  AUTO = "AUTO",
  FULL = "FULL",
  AUTO_FULL = "Auto Full",
}
